import { httpStatuses } from '@reveni-io/reveni-ui'

export const isChargebackError = error => {
  return error?.response?.status === httpStatuses.unprocessableEntity && error?.response?.data?.code === 'chargeback'
}
